import { APIClient } from '../api_helper';
import { api } from '../../config';
import * as url from '../transfer/url_helper';

import qs from 'qs';

const apiClient = new APIClient(api.REACT_APP_SPED_TRANSFER_API_URL);

export const stringifyParams = params =>
	qs.stringify(params, { encodeValuesOnly: true });

// Transfer
export const getTransferList = params => {
	return apiClient.get(`${url.GET_TRANSFERS}?${stringifyParams(params)}`);
};
export const getTransfer = transfer =>
	apiClient.get(url.TRANSFER + '/' + encodeURIComponent(transfer));
export const addNewTransfer = transfer =>
	apiClient.post(url.ADD_TRANSFER, transfer);
export const updateTransfer = transfer =>
	apiClient.put(url.UPDATE_TRANSFER + '/' + transfer._id, transfer);
export const deleteTransfer = transfer =>
	apiClient.delete(url.DELETE_TRANSFER + '/' + transfer._id);

// Transfer Category
export const getTransferCategoryList = () =>
	apiClient.get(url.GET_TRANSFER_CATEGORIES);
export const getTransferCategory = transferCategory =>
	apiClient.get(
		url.TRANSFER_CATEGORY + '/' + encodeURIComponent(transferCategory)
	);
export const addNewTransferCategory = transferCategory =>
	apiClient.post(url.ADD_TRANSFER_CATEGORY, transferCategory);
export const updateTransferCategory = transferCategory =>
	apiClient.put(
		url.UPDATE_TRANSFER_CATEGORY + '/' + transferCategory._id,
		transferCategory
	);
export const deleteTransferCategory = transferCategory =>
	apiClient.delete(url.DELETE_TRANSFER_CATEGORY + '/' + transferCategory._id);

// Transfer Company
export const getTransferCompanyList = params => {
	return apiClient.get(
		`${url.GET_TRANSFER_COMPANIES}?${stringifyParams(params)}`
	);
};
export const getTransferCompany = transferCompany =>
	apiClient.get(
		url.TRANSFER_COMPANY + '/' + encodeURIComponent(transferCompany)
	);
export const existsTransferCompany = rut =>
	apiClient.get(url.EXISTS_TRANSFER_COMPANY + '/' + encodeURIComponent(rut));
export const addNewTransferCompany = transferCompany =>
	apiClient.post(url.ADD_TRANSFER_COMPANY, transferCompany);
export const updateTransferCompany = transferCompany =>
	apiClient.put(
		url.UPDATE_TRANSFER_COMPANY + '/' + transferCompany._id,
		transferCompany
	);
export const deleteTransferCompany = transferCompany =>
	apiClient.delete(url.DELETE_TRANSFER_COMPANY + '/' + transferCompany._id);

// Transfer Type
export const getTransferTypeList = () => apiClient.get(url.GET_TRANSFER_TYPE);
export const getTransferTypeListByCompany = transfer_company_id =>
	apiClient.get(url.GET_TRANSFER_TYPE_COMPANY + '/' + transfer_company_id);
export const getTransferType = transferType =>
	apiClient.get(url.TRANSFER_TYPE + '/' + encodeURIComponent(transferType));
export const existsTransferType = rut =>
	apiClient.get(url.EXISTS_TRANSFER_TYPE + '/' + encodeURIComponent(rut));
export const addNewTransferType = transferType =>
	apiClient.post(url.ADD_TRANSFER_TYPE, transferType);
export const updateTransferType = transferType =>
	apiClient.put(
		url.UPDATE_TRANSFER_TYPE + '/' + transferType._id,
		transferType
	);
export const deleteTransferType = transferType =>
	apiClient.delete(url.DELETE_TRANSFER_TYPE + '/' + transferType._id);

// Transfer Driver
export const getTransferDriverList = params => {
	return apiClient.get(
		`${url.GET_TRANSFER_DRIVERS}?${stringifyParams(params)}`
	);
};
export const getTransferDriverListQuery = params => {
	return apiClient.get(
		`${url.GET_TRANSFER_DRIVERS_QUERY}?${stringifyParams(params)}`
	);
};
export const getTransferDriver = transferDriver =>
	apiClient.get(
		url.TRANSFER_DRIVER + '/' + encodeURIComponent(transferDriver)
	);
export const addNewTransferDriver = transferDriver =>
	apiClient.post(url.ADD_TRANSFER_DRIVER, transferDriver);
export const updateTransferDriver = transferDriver =>
	apiClient.put(
		url.UPDATE_TRANSFER_DRIVER + '/' + transferDriver._id,
		transferDriver
	);
export const deleteTransferDriver = transferDriver =>
	apiClient.delete(url.DELETE_TRANSFER_DRIVER + '/' + transferDriver._id);
